import React, { ChangeEvent, useState } from 'react';

import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import { Fade } from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import { TextFieldProps } from '@mui/material/TextField';

import { PageSearchTextField, SearchIconWrap } from './style';

export type ISearchProps = TextFieldProps & {
	onSearch: (e: any) => void;
};

function PageSearchField({ onSearch, ...props }: ISearchProps) {
	const [values, setValues] = useState('');
	const [isExpanded, setIsExpanded] = useState(false);

	const handleClear = () => {
		if (onSearch) {
			values && onSearch('');
		}
		setValues('');
		setIsExpanded(false);
	};

	const handleSearch = (e: ChangeEvent<HTMLInputElement>) => {
		const { value } = e.target;
		if (onSearch) {
			onSearch(value);
		}
		setValues(value);
	};

	const handleIconClick = () => {
		setIsExpanded(true);
	};

	return (
		<>
			<PageSearchTextField
				variant="outlined"
				onChange={handleSearch}
				expanded={isExpanded}
				{...props}
				value={values}
				InputProps={{
					endAdornment: (
						<InputAdornment position="end">
							{values || isExpanded ? (
								<ClearIcon onClick={handleClear} style={{ cursor: 'pointer' }} />
							) : (
								<SearchIcon />
							)}
						</InputAdornment>
					),
					sx: { borderRadius: '10px', width: '100%' },
				}}
			/>
			<Fade in={!isExpanded} timeout={700}>
				<SearchIconWrap onClick={handleIconClick} size="large">
					<SearchIcon />
				</SearchIconWrap>
			</Fade>
		</>
	);
}

export default PageSearchField;
